<template>
  <div class ="social-signin" id= "linkedin" @click="onClick">
    <img class = "social-logo" src="/static/images/signin/linkedin/linkedin.svg"><!--id="linkedin"-->
    <div class="social-text" id="linkedin"><slot>Sign in with LinkedIn</slot></div><!--id="linkedin"-->
  </div>
</template>

<style>
@import "~scss/social.scss";
</style>


<script>
import {stringify} from 'qs';
import {mapActions} from 'vuex';

export default {
  data() {
    return {ready: true};
  },
  mounted() {
    window.onOauth = (provider, {code}) => {
      this.$emit('login', {provider, code});
    };
  },
  beforeDestroy() {
    delete window.onOauth;
  },
  methods: {
    onClick() {
      const base = 'https://www.linkedin.com/oauth/v2/authorization';
      const params = {
        response_type: 'code',
        client_id: '86em1vwv504o9r',
        redirect_uri: window.location.origin + '/oauth/linkedin',
        state: '987654321', // we don't check this so no point making it random
        scope: 'r_basicprofile r_emailaddress'
      };
      const url = `${base}?${stringify(params)}`;
      window.open(url, 'linkedinAuth', 'width=600,height=400');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/LinkedInSignIn.vue